import React from "react";
import { useTranslation } from "react-i18next";

import { useDeleteDirection } from "~/entity/Directions/hooks/useDeleteDirection";
import { useGetLocationData } from "~/hooks/locationData";
import { useNotify } from "~/shared/hooks/useNotify";
import { ConfirmModal } from "~/shared/ui/ConfirmModal";

type Props = {
  isOpen: boolean;
  closeModal: () => void;
  refetch: () => void;
  currentData: any[];
};

const DeleteDirectionModal = ({
  isOpen,
  closeModal,
  refetch,
  currentData,
}: Props) => {
  const { t } = useTranslation();
  const { currentId } = useGetLocationData();
  const { notifySuccess, notifyError } = useNotify();
  const { deleteFn } = useDeleteDirection();

  const direction = currentData?.find((item) => item.id === Number(currentId));

  const deleteDirection = () => {
    if (!direction) {
      return;
    }

    deleteFn(direction.instanceId, {
      onSuccess: () => {
        notifySuccess(t("common.сhange_was_successful"));
        refetch();
        closeModal();
      },
      onError: (error) => {
        notifyError(error?.message || "Ошибка выполнения запроса");
        closeModal();
      },
    });
  };

  return (
    <ConfirmModal
      open={isOpen}
      title={t("directions.delete_direction")}
      text={t("directions.delete_confirm", { name: direction?.name })}
      onConfirm={deleteDirection}
      onCancel={closeModal}
      centered
    />
  );
};

export default DeleteDirectionModal;
